module.exports = __webpack_public_path__ + "img/notice.e5c8fb3.png";